<template>
  <div>
    <div v-if="loading">
      <v-card>
        <v-skeleton-loader
          ref="skeleton"
          type="table"
          class="mx-auto"
        ></v-skeleton-loader>
      </v-card>
    </div>
    <div v-else>
      <v-container fluid class="pl-5 pr-5">
        <v-card :elevation="0">
          <v-card-title>
            <v-row class="d-flex align-center">
              <v-col cols="8">
                Needs DEI Training
              </v-col>
              <v-col cols="4">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-title>
          <v-row>
            <v-col>
              <v-switch label="Managers Only" v-model="managersOnly"></v-switch>
            </v-col>
            <v-col>
              <v-switch label="Non Managers Only" v-model="nonManagersOnly"></v-switch>
            </v-col>
            <v-col>
              <v-switch label="Exclude Contingent Workers" v-model="excludeContingentWorkers"></v-switch>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headers"
            :items="needsTraining"
            :search="search"
            :loading="computedLoading"
          >
            <template v-slot:top>
              <v-container>
                <v-row class="d-flex justify-space-around align-center">
                  <v-col class="d-flex justify-end">
                    <CopyEmailsToClipboard class="pl-2" :emails="emailsToCopyToClipboard"/>
                  </v-col>
                </v-row>
              </v-container>
            </template>
            <template v-slot:item.avatar="{ item }" >
              <Avatar :employee="item" :size="30" :hideHeadline="true" />
            </template>
            <template v-slot:item.fields.Name="{ item }" >
              <router-link 
                :to="{ name: 'Employee', params: { id: item.id } }"
              >
              {{ item.fields.Name }}
              <v-chip
                x-small
                v-bind="attrs" v-on="on"
                v-if="item.fields.Status === 'Inactive'" 
                class="error text-uppercase"
              >Inactive</v-chip>
              </router-link>
            </template>
          </v-data-table>
        </v-card>
      </v-container>

    </div>
  </div>
</template>

<script>
  import Avatar from '@/components/employee/Avatar'
  import CopyEmailsToClipboard from '@/components/session/CopyEmailsToClipboard'
  
  export default {
    name: 'ReportDei',
    components: {
      Avatar,
      CopyEmailsToClipboard
    },
    props: {
      loading: Boolean,
      session: Object
    },
    data () {
      return {
        search: '',
        managersOnly: false,
        nonManagersOnly: false,
        loadingEmployees: true,
        excludeContingentWorkers: true,
        headers: [
          {
            text: '',
            sortable: false,
            value: 'avatar'
          },
          {
            text: 'Name',
            align: 'start',
            sortable: true,
            value: 'fields.Name'
          },
          {
            text: 'Title',
            align: 'start',
            sortable: true,
            value: 'fields.Title'
          },
          {
            text: 'Email',
            align: 'start',
            sortable: true,
            value: 'fields.Email'
          },
          {
            text: 'Manager Email',
            align: 'start',
            sortable: true,
            value: 'fields.Manager Email'
          },
          {
            text: 'Department',
            align: 'start',
            sortable: true,
            value: 'fields.Department'
          },
          {
            text: 'Location',
            align: 'start',
            sortable: true,
            value: 'fields.Location Formatted'
          },
          {
            text: 'Is In ADP',
            align: 'start',
            sortable: true,
            value: 'fields.Is In ADP'
          },
          {
            text: 'Is Manager',
            align: 'start',
            sortable: true,
            value: 'isManager'
          }
        ]
      }
    },
    computed: {
      needsTraining () {
        let emps = this.$store.getters.getEmployees.filter(e => {
          console.log(e.fields.Name + ' ' + e.fields['Requires DEI Training'])
          return e.fields['Requires DEI Training'] && e.fields.Status !== 'Inactive'
        }).map(e => {
          e.isManager = this.employees.filter(emp => emp.fields['Manager Email'] === e.fields.Email).length > 0
          return e
        })
        if (this.managersOnly) {
          emps = emps.filter(e => e.isManager)
        }
        if (this.nonManagersOnly) {
          emps = emps.filter(e => !e.isManager)
        }
        if (this.excludeContingentWorkers) {
          emps = emps.filter(e => e.fields['Is In ADP'])
        }
        return emps
      },
      emailsToCopyToClipboard () {
        // use filtered attendees so that filters apply when copying emails
        return this.needsTraining.map(a => {
          return a.fields.Email
        })
      },
      employees () {
        return this.$store.getters.getEmployees
      },
      computedLoading () {
        return !this.loadingEmployees
      },
    },
    created () {
      this.init()
    },
    methods: {
      init () {
        return new Promise((resolve, reject) => {
          this.$store.dispatch('getRecords', {
            table: 'Employees',
            view: 'All Employees',
            dispatch: 'setEmployees'
          })
          .then(() => {
            this.employees = false
            return resolve()
          })
          .catch((err) => {
            return reject(err)
          })
        })
      },
    }
  }
</script>
